export const DEFAULT_COUNTRY = 'CA';

export const getDefaultWelcomeMessage = (): string => {
  const welcome = process.env.REACT_APP_WELCOME_DEFAULT;
  if (welcome) return welcome;
  return 'Hello, thank you for calling {company_name}. How can I help you?';
};

export const getDefaultGoodbyeMessage = (): string => {
  return 'Thank you for calling {company_name}. Have a great day!';
};

export const getDefaultRecordingNotice = (companyName: string) => {
  return {
    key: '{recording_notice}',
    value: `This call may be recorded for quality assurance.`,
  };
};
